// Shared IST date/time formatters. All user-visible dates in the app flow
// through these helpers so the display is consistent and always in
// Asia/Kolkata (IST), regardless of the viewer's browser timezone.

const IST_ZONE = 'Asia/Kolkata';

function _toDate(input) {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input) ? null : input;
  const d = new Date(input);
  return isNaN(d) ? null : d;
}

// "20-Apr-2026"
export function formatDateIST(input) {
  const d = _toDate(input);
  if (!d) return '';
  return d.toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: IST_ZONE,
  }).replace(/ /g, '-');
}

// "12:30 AM"
export function formatTimeIST(input) {
  const d = _toDate(input);
  if (!d) return '';
  return d.toLocaleTimeString('en-IN', {
    hour: '2-digit', minute: '2-digit', hour12: true, timeZone: IST_ZONE,
  });
}

// "20-Apr-2026 12:30 AM"
// When `timeStr` is an explicit HH:mm string (coming from an external system
// that already has the time in IST, e.g. appointment slots), use it verbatim.
export function formatDateTimeIST(input, timeStr) {
  const dateStr = formatDateIST(input);
  if (!dateStr) return '';
  if (timeStr) return `${dateStr} ${timeStr}`;
  const t = formatTimeIST(input);
  return t ? `${dateStr}, ${t}` : dateStr;
}

// "2 days ago" / "just now" / "5h ago"
export function timeAgoIST(input) {
  const d = _toDate(input);
  if (!d) return '';
  const diff = Date.now() - d.getTime();
  if (diff < 60000) return 'just now';
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}

// "YYYY-MM-DD" for the current instant, resolved in IST. Use this
// (never `new Date().toISOString().slice(0, 10)`) when deriving the
// "today's date" string that the backend queues / sessions collections
// are keyed on, so a user checking in at 01:00 IST still lands on
// today's board rather than yesterday's (which is what raw UTC gives
// between 00:00 and 05:30 IST).
export function todayIST() {
  return toDateIST(new Date());
}

// Format ANY Date instance to the "YYYY-MM-DD" date string it falls
// on in Asia/Kolkata. Useful when generating a date range keyed to the
// Indian clinic day (roster grids, booking date strips, etc.).
export function toDateIST(input) {
  const d = _toDate(input);
  if (!d) return '';
  // en-CA uses ISO-8601 formatting (YYYY-MM-DD) which is exactly the
  // shape the backend + Mongo indexes expect.
  return d.toLocaleDateString('en-CA', { timeZone: IST_ZONE });
}

